import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { Table } from 'reactstrap';

import { ROUTES, insertCustomSurveyIdtoUrl } from 'constants/Routes.js';
import SurveyApi from 'apis/Survey';

class CustomSurveyNameList extends Component {
  constructor() {
    super();
    this.state = {
      searchText: '',
      customSurveys: [],
    };
  }

  componentDidMount() {
    this.fetchCustomSurveys();
  }

  handleFilter = e => {
    const { value } = e.target;
    const searchText = value.toLowerCase();
    this.setState({ searchText });
  };

  fetchCustomSurveys = () => {
    const { match } = this.props;
    const { params } = match;
    const { id: businessId } = params;

    SurveyApi.getAll(businessId)
      .then(({ data }) => {
        this.setState({ customSurveys: data });
      })
      .catch(e => console.log(e));
  };

  getNavUrl = id => {
    const { match } = this.props;
    const { params } = match;
    const { id: businessId } = params;

    const navUrl = insertCustomSurveyIdtoUrl(
      ROUTES.CUSTOM_SURVEY_FEEDBACKS,
      businessId,
      id
    );
    return navUrl;
  };

  render() {
    const { searchText, customSurveys } = this.state;
    const filteredSurveys = customSurveys.filter(
      ({ name }) =>
        name && name.toLowerCase().includes(searchText.toLowerCase())
    );
    const customSurveysList = filteredSurveys.map(({ id, name }) => {
      return (
        <tr key={id}>
          <td>
            <NavLink to={this.getNavUrl(id)} activeClassName="navActive">
              {name || 'Survey'}
            </NavLink>
          </td>
        </tr>
      );
    });

    return (
      <Fragment>
        <Table
          hover
          className="styled-box-shadow left-nav-box"
          id="reportsTable"
        >
          <thead>
            <tr>
              <th className="report-th">Soono Surveys</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                <form autoComplete="off">
                  <input
                    className="form-control bg-light"
                    type="search"
                    placeholder="Search"
                    id="reportsInput"
                    onChange={this.handleFilter}
                  />
                </form>
              </th>
            </tr>
            {customSurveysList}
          </tbody>
        </Table>
      </Fragment>
    );
  }
}

CustomSurveyNameList.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

export default withRouter(CustomSurveyNameList);



// WEBPACK FOOTER //
// ./src/components/feedbackReport/customSurveysNameList.js